import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-onboarding-dialog',
  templateUrl: './onboarding-dialog.component.html',
  styleUrls: ['./onboarding-dialog.component.scss']
})
export class OnboardingDialogComponent {
  constructor(public dialogRef: MatDialogRef<OnboardingDialogComponent>){

  }

  closeDialog() {
    this.dialogRef.close('Pizza!');
  }

  
}
